import { Component } from '@angular/core';

@Component({
	selector: 'typography-cmp',
	moduleId: module.id,
	templateUrl: 'typography.component.html'
})
export class TypographyComponent {}



// WEBPACK FOOTER //
// /Users/baselkilani/work/ODOT/projects/dmscontrol/DmsControl/src/app/typography/typography.component.ts